export enum PlanType {
  YEARLY = 'yearly',
  RECURRENCY = 'recurrency',
  MONTHLY = 'monthly',
  SEMESTER = 'semester',
}
